import React from 'react';
import { LocationSearchType } from '@/containers/SearchFlightTab/SearchDialog/index.d';
import SearchFormInput from '@/containers/SearchFlightTab/SearchFormInput';
import { addAllHomePoints } from '@/slices/area/slices/searchFlightFormSlice';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { VectorIcon } from 'public/icons';
import { useDispatch } from 'react-redux';

function SearchInput() {
  const dispatch = useDispatch();
  const {
    startPointHome: startPoint, toPointHome: toPoint,
  } = useAppSelector((state) => state.searchFlightForm);

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      gap: '10px',
    }}
    >
      <Box sx={{ width: '40%' }}>
        <SearchFormInput
          isDesktop
          type={LocationSearchType.FROM}
        />
      </Box>
      <VectorIconWrapper>
        <IconButton
          onClick={() => {
            dispatch(addAllHomePoints([
              {
                data: startPoint,
                type: 'to',
              }, {
                data: toPoint,
                type: 'from',
              },
            ]));
          }}
          style={{
            width: 40,
            height: 40,
            transform: 'rotate(90deg)',
          }}
        >
          <VectorIcon color={style.color.black4} />
        </IconButton>
      </VectorIconWrapper>
      <Box sx={{ width: '40%' }}>
        <SearchFormInput
          isDesktop
          type={LocationSearchType.TO}
        />
      </Box>

    </div>
  );
}

export const VectorIconWrapper = styled('div')({
  display: 'inline',
  background: style.color.white4,
  borderRadius: '50%',
  position: 'absolute',
  top: '50%',
  left: '38.5%',
  zIndex: 99,
  transform: 'translateY(-53%)',
  boxShadow: style.boxShadow.customShadow,
});

export default React.memo(SearchInput);
